import { css } from '@linaria/core';
import theme from '../../../theme';

export const toggle = css`
  height: 24px;
  width: 40px;
  background: #ffffff;
  border-radius: 24px;
  transition: background 100ms ease-in;
  display: block;
  cursor: pointer;
  position: relative;
  border: 1px solid ${theme.colors.neutral['95']};

  &:hover {
  }

  &:has(input:checked) {
    background: ${theme.colors.neutral['95']};
    &:hover {
    }

    &::after {
      transform: translateX(calc(40px - 100% - (4px * 2)));
      background: #ffffff;
    }
  }

  &:has(input[disabled]) {
    cursor: not-allowed;
    background: ${theme.colors.neutral['30']};
    &:hover {
    }

    &::after {
      background: ${theme.colors.neutral['20']};
    }

    border-color: ${theme.colors.neutral['30']};
    &:has(input:checked) {
      background: ${theme.colors.neutral['20']};
      &::after {
        background: ${theme.colors.neutral['30']};
      }
    }
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: inherit;
    background: ${theme.colors.neutral['95']};
    width: 16px;
    height: 16px;
    margin: 3px;
    transition: transform 300ms ease-in-out;
  }
`;
